exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3xKay8FcF2yAIw-klupmOZ{cursor:pointer;white-space:nowrap}", ""]);
// Exports
exports.locals = {
	"link": "_3xKay8FcF2yAIw-klupmOZ"
};